import {createSelector} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";

const baseState = state => state.suggested;
const baseData = createSelector([baseState], (state) => state.data);

export const suggestedErrorSelector = createSelector([baseState], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    };
});
export const suggestedDataSelector = createSelector([baseData], (state) => {
    return {
        video: Object.values(state.video),
        directory: Object.values(state.directory),
        event: Object.values(state.event),
        thread: Object.values(state.thread)
    };
})